import moment from 'moment'

import ExpandIcon from '@assets/images/select-expand-icon.svg?react'

import { DatePicker } from '@components/DatePicker'
import { DropDown } from '@components/DropDown'

import { Container, ExpandContainer, FakeInput, Label, Placeholder, TextInputContainer } from './SelectDate.styled'

interface Props {
  date?: Date
  onChange: (date: Date) => void
  label?: string
  placeholder?: string
  required?: boolean
  fullWidth?: boolean
  disabled?: boolean
}

export const SelectDate: React.FC<Props> = ({
  placeholder,
  date,
  label,
  fullWidth = false,
  required = false,
  disabled = false,
  onChange,
}: Props) => {
  return (
    <DropDown
      disabled
      WrappedComponent={({ display, hide, show }) => (
        <Container>
          {label && <Label>{label}</Label>}

          <TextInputContainer
            fullWidth={fullWidth}
            onClick={disabled ? undefined : () => (display ? hide() : show())}
            style={{ cursor: disabled ? 'default' : 'pointer' }}
          >
            <Placeholder
              className="placeholder"
              style={{ flex: 1, cursor: disabled ? 'default' : 'pointer' }}
              hasValue={!!date}
            >
              {date ? moment(date).format('DD/MM/YYYY') : placeholder}
            </Placeholder>
            <FakeInput
              type="text"
              onChange={() => {}}
              required={required}
              value={date ? moment(date).format('DD/MM/YYYY') : ''}
              style={{ opacity: 0, cursor: disabled ? 'default' : 'pointer' }}
            />

            <ExpandContainer disabled={disabled}>
              <ExpandIcon />
            </ExpandContainer>
          </TextInputContainer>
        </Container>
      )}
      WrappedChildren={({ hide, display }) =>
        display ? (
          <DatePicker
            selectedDate={date}
            onChange={(date) => {
              date && onChange(date)
              hide()
            }}
          />
        ) : (
          <></>
        )
      }
    />
  )
}
